import { createAction, props } from '@ngrx/store';
import { IGenerateRefundStatementRequest } from '../models/generate-refund-statement-request.model';
import { IGenerateRefundStatementResponse } from '../models/generate-refund-statement-response.model';

export const generateRefundStatement = createAction(
  '[Outstanding] Generate Refund Statement',
  props<{
    request: IGenerateRefundStatementRequest;
  }>()
);

export const generateRefundStatementSuccess = createAction(
  '[Outstanding] Generate Refund Statement Success',
  props<{ response: IGenerateRefundStatementResponse }>()
);

export const generateRefundStatementFailure = createAction(
  '[Outstanding] Generate Refund Statement Failure',
  props<{ error: Error | any }>()
);
